import React, { useEffect, useState } from 'react'
import { Loader } from 'react-feather';
import ManageTable from '../../../Manage/ManageTable';

const ActiveVouchers = () => {

    const [loading, setLoading] = useState(true)
    const [tableData, setTableData] = useState([])


    const mockData = [
        {
          sn: 1,
          voucher_code: "VOUCHER123",
          voucher_type: "Gift",
          monetary_value: "$10",
          remaining_value: "$10",
          validity_period: "30 March - 7 April",
          conditions: "30$",
          applied_to: "-",
          status: "Active",
          usage_limit: "1"
        },
        {
          sn: 2,
          voucher_code: "VOUCHER123",
          voucher_type: "Product-specific",
          monetary_value: "$10",
          remaining_value: "$10",
          validity_period: "30 March - 7 April",
          conditions: "30$",
          applied_to: "Specific products",
          status: "Active",
          usage_limit: "1"
        },
        {
          sn: 3,
          voucher_code: "VOUCHER123",
          voucher_type: "Gift",
          monetary_value: "$10",
          remaining_value: "$10",
          validity_period: "30 March - 7 April",
          conditions: "30$",
          applied_to: "-",
          status: "Active",
          usage_limit: "1"
        },
       
      ];
      
      const columns = [
        {
          name: "Voucher Code",
          cell: (row) => <span title={row.voucher_code} className="ellipsis">{row.voucher_code}</span>,
          selector: (row) => row.voucher_code,
          sortable: true,
        },
        {
          name: "Voucher Type",
          cell: (row) => <span title={row.voucher_type} className="ellipsis">{row.voucher_type}</span>,
          selector: (row) => row.voucher_type,
          sortable: true,
        },
        {
          name: "Monetary Value",
          cell: (row) => <span title={row.monetary_value} className="ellipsis">{row.monetary_value}</span>,
          selector: (row) => row.monetary_value,
          sortable: true,
        },
        {
          name: "Remaining Value",
          cell: (row) => <span title={row.remaining_value} className="ellipsis">{row.remaining_value}</span>,
          selector: (row) => row.remaining_value,
          sortable: true,
        },
        {
          name: "Validity Period",
          cell: (row) => <span title={row.validity_period} className="ellipsis">{row.validity_period}</span>,
          selector: (row) => row.validity_period,
          sortable: true,
        },
        {
            name: "Conditions",
            cell: (row) => <span title={row.conditions} className="ellipsis">
              {`Min.spent: ${row.conditions}`} <br/> {`Usage Limit: ${row.usage_limit}`} 
              </span>,
            selector: (row) => row.conditions,
            sortable: true,
          },
        {
          name: "Applied to",
          cell: (row) => <span title={row.applied_to} className="ellipsis">{row.applied_to}</span>,
          selector: (row) => row.applied_to,
          sortable: true,
        },
        {
          name: "Status",
          cell: (row) => (
            <span
              title={row.status}
              className="ellipsis"
              style={{ color: row.status === 'Active' ? '#41B8E4' : '#EC7426' }}
            >
              {row.status}
            </span>
          ),
          selector: (row) => row.status,
          sortable: true,
        },
      
      ];
      


    useEffect(() => {
        // Simulate fetching data
        setTableData(mockData);
        setLoading(false);
      }, []);

  return (
    <>
    <div>
       {loading ? <Loader /> :
          <ManageTable
            name={'All Vouchers'}
            // can_create={childPageData.can_create}
            columns={columns}
            setTableData={setTableData}
            tableData={tableData}
          />
        }
    </div>
    </>
  )
}

export default ActiveVouchers
